import apiService from './apiService';

const taskService = {
    // 1. Get List with Filters
    getTasks: async (filters = {}) => {
        const query = new URLSearchParams(filters).toString();
        // Correctly passes endpoint. method defaults to GET, isPublic defaults to false.
        return apiService.makeRequest(`/tasks?${query}`);
    },

    // 2. Create
    createTask: async (data) => {
        // Fix: Pass configuration object as 2nd arg, NOT separate args.
        // Previous bad code: apiService.makeRequest('/tasks', 'POST', data) 
        // -> interpreted 'POST' as options, data as isPublic=true -> No Token -> 401
        return apiService.makeRequest('/tasks', {
            method: 'POST',
            body: JSON.stringify(data)
        });
    },

    // 3. Update
    updateTask: async (id, data) => {
        return apiService.makeRequest(`/tasks/${id}`, {
            method: 'PUT',
            body: JSON.stringify(data)
        });
    },

    // 4. Delete
    deleteTask: async (id) => {
        return apiService.makeRequest(`/tasks/${id}`, {
            method: 'DELETE'
        });
    }
};

export default taskService;
